import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/IndexView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    meta: {
      title: '首页'
    },
  },
  {
    path: '/info',
    name: 'InfoView',
    meta: {
      title: '上传证件照'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InfoView.vue')
  },
  {
    path: '/invite',
    name: 'InviteView',
    meta: {
      title: '签约'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InviteView.vue')
  },
  {
    path: '/login',
    name: 'LoginView',
    meta: {
      title: '登录'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/address',
    name: 'AddressView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AddressView.vue')
  },
  {
    path: '/updateUser',
    name: 'UpdateUser',
    meta: {
      title: '更新身份证'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/UpdateUser.vue')
  },
  {
    path: '/insuranceRecord',
    name: 'InsuranceRecordView',
    meta: {
      title: '投保记录'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InsuranceRecordView.vue')
  },
  {
    path: '/insuranceDetail',
    name: 'InsuranceDetailView',
    meta: {
      title: '投保详情'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InsuranceDetailView.vue')
  },
  {
    path: '/fundRecord',
    name: 'FundRecordView',
    meta: {
      title: '周转金记录'
    },
    
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FundRecordView.vue')
  },
  {
    path: '/deviceRecord',
    name: 'DeviceRecordView',
    meta: {
      title: '设备缴费记录'
    },
    
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/DeviceRecordView.vue')
  },
  {
    path: '/taxSign',
    name: 'TaxSignView',
    meta: {
      title: '涉税信息报送'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/TaxSignView.vue')
  },
  {
    path: '/dingGroup',
    name: 'DingGroupView',
    meta: {
      title: '二维码'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/DingGroupView.vue')
  },
  {
    path: '/employment',
    name: 'EmploymentView',
    meta: {
      title: '劳动关系'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/EmploymentView.vue')
  },
  {
    path: '/message',
    name: 'MessageView',
    // 微信卡片落点为 ?messageId=xxx#/messages（复数），通过 alias 兼容
    alias: '/messages',
    meta: {
      title: '消息中心'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/MessageView.vue')
  },
  {
    path: '/payment',
    name: 'PaymentView',
    meta: {
      title: '周转金缴纳'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PaymentView.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

// 免登录白名单
const WHITE_LIST = ['LoginView']

const isLoggedIn = () => {
  if (!localStorage.getItem('userLogin')) {
    return false
  }
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))
    return !!(userData && userData.token)
  } catch (e) {
    return false
  }
}

// 登录拦截
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title || ''
  // 签约链接携带的推荐人信息先落地（无论是否已登录）：
  // 已登录可能只是本地有残留 token，随后接口 102 被踢回登录页时 query 会丢
  const { refereeNoId, region, orgDepartmentId, orgDepartmentName } = to.query
  if (refereeNoId) {
    localStorage.setItem('refereeNoId', refereeNoId)
    if (region) localStorage.setItem('region', region)
    if (orgDepartmentId) localStorage.setItem('orgDepartmentId', orgDepartmentId)
    if (orgDepartmentName) localStorage.setItem('orgDepartmentName', orgDepartmentName)
  }
  if (WHITE_LIST.includes(to.name) || isLoggedIn()) {
    next()
    return
  }
  next({
    name: 'LoginView',
    query: { ...to.query, redirect: to.fullPath }
  })
})

export default router
